import request from '@/utils/axios'
import qs from 'qs'


export function getStdNameByStdId(params) {
  let postData = qs.stringify(params)
  return request({
    url: '/api/manager/record/getStdNameByStdId',
    method: 'post',
    data: postData
  })
}

export function getRecordInfo(params) {
  let postData = qs.stringify(params)
  return request({
    url: '/api/manager/record/getRecordInfo',
    method: 'post',
    data: postData
  })
}

export function getRecordInfoByCourseId(params) {
  let postData = qs.stringify(params)
  return request({
    url: '/api/manager/record/getRecordInfoByCourseId',
    method: 'post',
    data: postData
  })
}

export function addRecord(params) {
  let postData = qs.stringify(params)
  return request({
    url: '/api/manager/record/addRecord',
    method: 'post',
    data: postData
  })
}

export function updateRecord(params) {
  let postData = qs.stringify(params)
  return request({
    url: '/api/manager/record/editRecord',
    method: 'post',
    data: postData
  })
}

export function deleteRecord(params) {
  let postData = qs.stringify(params)
  return request({
    url: '/api/manager/record/deleteRecord',
    method: 'post',
    data: postData
  })
}

export function batchDeleteRecord(params) {
  let postData = qs.stringify(params)
  return request({
    url: '/api/manager/record/batchDeleteRecord',
    method: 'post',
    data: postData
  })
}